import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import Header from '../../../../Components/Header';
import Footer from '../../../../Components/Footer';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import SVGCurveLine from '../../../../Hooks/SVGCurveLine'; 
import { GoNorthStar } from "react-icons/go";
import { PiSlideshow, PiStarFourFill } from "react-icons/pi";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { GoPlus } from "react-icons/go";
import starY from '../../../../Assets/Images/icons/star.webp';

import logo from "../../../../Assets/Images/logos/work/real-estate/credai-mchi.png"
import ourwork1 from '../../../../Assets/Images/work/ryan-group/ryangroup-main.webp';
import ourwork2 from '../../../../Assets/Images/work/ryan-group/ryanslide-1.webp';
import ourwork3 from '../../../../Assets/Images/work/ryan-group/ryanslide-2.webp';
import ourwork4 from '../../../../Assets/Images/work/ryan-group/ryanslide-3.webp';
import ourwork5 from '../../../../Assets/Images/work/ryan-group/ryanslide-4.webp';
import ourwork6 from '../../../../Assets/Images/work/ryan-group/ryanslide-5.webp';

import CaseStudyNav from '../../../../Components/PerformanceMarketingCaseStudyNav';

// CaseStudySlider 
const CaseStudySlider = {
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 7000,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
    {
        breakpoint: 968,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        },
    },
    {
        breakpoint: 768,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        },
    },
    ],
};
// CaseStudySlider End

// Slider

const mainSlider ={
    dot: false,
    arrows:true,
    infinite:true,
    autoplay:true,
    autoplaySpeed: 7000,
    speed:700,
    slideToShow:3,
    slidesToScroll:1,
    responsive: [
        {
            breakpoint:768,
            settings:{
                arrow:false,
            }
        }
    ]
}

// Slider

//CaseStudy Data
const CaseStudyData = [
    {
        link: '#',
        image: ourwork1,
        titale: 'Brand led site for a Banking Solutions Firm',
        tags: [{ name: 'BFSI' },],
    },  
    {
        link: '#',
        image: ourwork2,
        titale: 'A dynamic website for India’s biggest truck company',
        tags: [
            { name: 'Automobile' },
        ],
    },  
    {
        link: '#',
        image: ourwork3,
        titale: 'Revamped Website for one of the India’s biggest institution',
        tags: [{ name: 'Education' },],

    },
  ];
//CaseStudy Data End

const LeveragingDigitaltoGenerateOnlineRegistrationsforanEventMCHIMahaPropertyExpo = () => {


  return (
    <>
    <Helmet>
<title>Digital Campaign for Event Registrations | MCHI Maha Expo</title>
<link rel="canonical" href="https://www.agency09.in/about"/>
<meta name="robots" content="index, follow"/> 

<meta name="description" content="Learn how AGENCY09 utilized digital strategies to drive online registrations for the MCHI Maha Property Expo, ensuring maximum reach and engagement."/>
<meta property="og:title" content="Digital Campaign for Event Registrations | MCHI Maha Expo"/> 
<meta property="og:description" content="Learn how AGENCY09 utilized digital strategies to drive online registrations for the MCHI Maha Property Expo, ensuring maximum reach and engagement."/> 
<meta property="og:image" content="https://www.agency09.in/agency09.png"/> 
<meta property="og:type" content="website"/> 


<meta name="twitter:card" content="summary"/> 
<meta name="twitter:site" content="@AGENCY09"/> 
<meta name="twitter:creator" content="@AGENCY09"/> 
<meta name="twitter:url" content="https://www.agency09.in/about"/> 
<meta name="twitter:description" content="Learn how AGENCY09 utilized digital strategies to drive online registrations for the MCHI Maha Property Expo, ensuring maximum reach and engagement."/> 
<meta name="twitter:image" content="https://www.agency09.in/agency09.png"/> 

</Helmet>
    <Header/>
    <div className="spacer"></div>


    <section className='cSsecMin'>
        <div className='container'>
            
            <div className='cSsecMinA flexBio'>

                <div className='cSsecMinBtn m0'>
                <Link to='/work/case-studies' className='backBtn'><span><IoArrowBackCircleOutline /> Case Study</span></Link>
                </div>

                <div className='cSsecMinHead m0'>
                    <h1 className='sizeH4'>Leveraging Digital to Generate Online Registrations for an Event: MCHI Maha Property Expo</h1>
                </div>

                <div className='cSsecMinInfo m0'>
                    <img src={logo} loading='lazy' />
                    {/* <Link>Info <GoPlus /></Link> */}
                </div>

            </div>

            <div className='strokeB'>
                <SVGCurveLine/>
            </div>  


            <div className='cSsecMinB'>
                <div className='cSsecMinBRow'>
                    <div className='cSsecMinBCol'>
                        <h4>Overview</h4>
                        <p>MCHI organized their 29th Edition of the Maha Property Expo to showcase the newest and biggest properties in MMR.</p>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Industry</h4>
                        <p> Real Estate</p>
                    </div>
                    
                    <div className='cSsecMinBCol'>
                        <h4>Services</h4>
                       <p> Design & Content, Paid Ads, Production, Microsite</p>
                    </div>
                    
                    <div className='cSsecMinBCol'>
                    <h4>Year </h4>
                    <p>2019</p>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Objective</h4>
                        <ul>
                            <li>To generate record pre-event registration.</li>
                            <li>Create hype around the event to get maximum footfall.</li>
                        </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Challenges</h4>
                        <ul>
                            <li>Efficiently managing and processing a high volume of registrations.</li>
                            <li>Ensuring broad reach and engagement through digital channels.</li>
                            <li>Maximizing footfall during the event.</li>
                        </ul>
                    </div>

                

                    <div className='cSsecMinBCol'>
                        <h4>Approach</h4>
                        <ul>
                            <li>Create an online module to manage leads.</li>
                            <li>Generate content to promote the event online.</li>   
                            <li>Reach out to the target group via paid ads.</li> 
                            <li>Register people for the event via Social Media forms and Call Centers.</li>
                            <li>Cover the event via on-ground coverage.</li>                     
                        </ul>
                    </div>

                    <div className='cSsecMinBCol '>
                        <h4>Results</h4>
                        <ul>
                            <li>26,337 Unique Registrations</li>
                            <li>17M+ Impressions</li>
                            <li>60+ Unique Content Pieces Created</li>
                            <li>All achieved within 21 days</li>
                        </ul>
                    </div>

                </div>

            </div>


            {/* <div className='cSsecMinC'>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork1} /></span>
                </div>

            </div>


            <div className='mainslider'>
                <Slider {...mainSlider} className='clientelSlider slick-slider'>
                <div className='imgCol1 imgCol'>
                                <span><img src={ourwork2} /></span>
                            </div>

                            <div className='imgCol1 imgCol'>
                                <span><img src={ourwork3} /></span>
                            </div>


                </Slider>
            </div> */}




        </div>
    </section>




<CaseStudyNav/>

    <Footer/>
    </>
  )
}

export default LeveragingDigitaltoGenerateOnlineRegistrationsforanEventMCHIMahaPropertyExpo
